/*
 * @Author: DQL
 * @Date: 2020-03-18 09:56:04
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:33:48
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

export const deptService = {
  // 获取树
  getTree: (params) => { return axios.get(`${commontCtx}/dept/tree/async`, { params: params }); },

  // 获取
  get: (deptCode) => { return axios.get(`${commontCtx}/dept/v2/${deptCode}`); },

  // 新增
  save: (params) => { return axios.post(`${commontCtx}/dept/save`, params); },

  // 修改
  update: (params) => { return axios.put(`${commontCtx}/dept/update`, params); },

  // 删除
  delete: (deptCode) => { return axios.delete(`${commontCtx}/dept/delete/${deptCode}`); }
};
